import {
  EVENT_DESELECT,
  EVENT_DESTROY,
  EVENT_EDGE_ADDED,
  EVENT_EDGE_REMOVED,
  EVENT_EDGE_SOURCE_CHANGED,
  EVENT_EDGE_TARGET_CHANGED,
  EVENT_EDGE_UPDATED,
  EVENT_NODE_ADDED,
  EVENT_NODE_MOVE_END,
  EVENT_NODE_MOVE_START,
  EVENT_NODE_REMOVED,
  EVENT_NODE_UPDATED,
  EVENT_PORT_ADDED,
  EVENT_PORT_REMOVED,
  EVENT_PORT_UPDATED,
  EVENT_SELECT,
  EVENT_SELECTION_CLEARED,
  EVENT_UNDOREDO_UPDATE,
  Edge,
  EdgePathEditor,
  JsPlumbToolkit,
  Node,
  ObjectData,
  Surface,
  SurfaceMode
} from "@jsplumbtoolkit/browser-ui";
import { BrowserUIReact, JsPlumbToolkitMiniviewComponent, JsPlumbToolkitSurfaceComponent, newInstance } from "@jsplumbtoolkit/browser-ui-react";
import { NormalQuestInterface, QuestInterface } from "@swivl-mono/types";
// import ReactJson from "react-json-view";
import JsonView from "@uiw/react-json-view";
import React from "react";

import { InheritanceTag } from "../../../../Components/InheritanceTag/InheritanceTag";
import {
  OFFSET_INCREMENT,
  calculateSafePosition,
  cloneNodeData,
  createIdMapping,
  filterOutStartNodes,
  generateUniqueNodeId,
  isStartNode,
  updateGotosForDuplicates
} from "../../../../Helpers/NodeDuplication/NodeDuplication.Helper";
import { Member } from "../../../../Models/Member/Member.Current";
import { NavBar } from "../../../../Models/NavBar/NavBar.Model";
import { SwivlNavigateFunction } from "../../../../Models/NavBar/useSwivlNavigate";
import { QuestsModel } from "../../../../Models/Quests/Quests.Model";
import NodeModel from "../Nodes/NodeModel";
import { EditorSidePanel } from "../SidePanel/EditorSidePanel";
import BrainsDropdown from "./Components/BrainsDropdown/BrainsDropdown";
import { CanvasControls } from "./Components/Controls/CanvasControls";
import IssuesView from "./Components/Issues/IssuesView";
import { EditorSaveButton } from "./Components/SaveButton/EditorSaveButton";
import { CanvasConfigRenderParams, CanvasConfigView } from "./Config/CanvasConfig";
import "./EditorCanvas.scss";
import { CanvasHelpers } from "./Methods/CanvasHelpers";
import { PlumbDataFromQuest } from "./Methods/PlumbDataFromQuest";
import { QuestDataFromPlumb } from "./Methods/QuestDataFromPlumb";

// import _ from "lodash";
// OrthogonalConnectorEditor.initialize();

type CancelFunction = () => any;
type CommitFunction = (data: Record<string, any>) => any;

export type DialogManager = {
  showEdgeLabelDialog: (data: ObjectData, callback: Function, abort: CancelFunction) => any;
  confirmDelete: (data: ObjectData, callback: CommitFunction) => any;
  editName: (data: ObjectData, callback: CommitFunction) => any;
};

interface Props {
  quest: NormalQuestInterface;
  navigate: SwivlNavigateFunction;
  canEdit: boolean;
}
interface State {
  showControls: boolean;
  isDirty: boolean;
  isSaving: boolean;
  inTestMode: boolean;
  selectedNodes: Node[];
}

export class EditorCanvas extends React.Component<Props, State> {
  toolkit: BrowserUIReact;
  view: any;
  surface?: Surface;
  surfaceComponent?: JsPlumbToolkitSurfaceComponent;
  controls: any;
  pathEditor?: EdgePathEditor;

  renderParams: any;
  loaded: boolean = false;
  constructor(props: Props) {
    super(props);

    this.state = {
      showControls: false,
      isDirty: false,
      isSaving: false,
      inTestMode: false,
      selectedNodes: []
    };
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
    this.setNavBar = this.setNavBar.bind(this);

    this.dataChanged = this.dataChanged.bind(this);
    this.nodeClicked = this.nodeClicked.bind(this);
    this.removeEdge = this.removeEdge.bind(this);
    this.canvasClicked = this.canvasClicked.bind(this);
    this.selectionUpdated = this.selectionUpdated.bind(this);
    this._selectionUpdated = this._selectionUpdated.bind(this);
    this.dataChanged = this.dataChanged.bind(this);
    this.portChanged = this.portChanged.bind(this);
    this.saveQuest = this.saveQuest.bind(this);
    this.loadData = this.loadData.bind(this);

    this.nodeAdded = this.nodeAdded.bind(this);
    this.updateNode = this.updateNode.bind(this);
    this.deleteNodes = this.deleteNodes.bind(this);

    this.shouldDrag = this.shouldDrag.bind(this);
    this.duplicateNode = this.duplicateNode.bind(this);
    this.duplicateNodes = this.duplicateNodes.bind(this);
    this.duplicateNodesToQuest = this.duplicateNodesToQuest.bind(this);

    this.toolkit = newInstance();
    this.view = CanvasConfigView(this.nodeClicked, this.removeEdge, this.props.canEdit);
    this.renderParams = CanvasConfigRenderParams(this.canvasClicked, this.shouldDrag);

    this.panToAndSelectNode = this.panToAndSelectNode.bind(this);

    this.toolkit.bind(EVENT_PORT_ADDED, this.dataChanged);
    this.toolkit.bind(EVENT_PORT_REMOVED, this.dataChanged);
    this.toolkit.bind(EVENT_PORT_UPDATED, this.dataChanged);
    this.toolkit.bind(EVENT_NODE_ADDED, this.nodeAdded);
    this.toolkit.bind(EVENT_NODE_REMOVED, this.dataChanged);
    this.toolkit.bind(EVENT_NODE_UPDATED, this.dataChanged);
    this.toolkit.bind(EVENT_EDGE_ADDED, this.portChanged);
    this.toolkit.bind(EVENT_EDGE_UPDATED, this.portChanged);
    this.toolkit.bind(EVENT_EDGE_REMOVED, this.portChanged);
    this.toolkit.bind(EVENT_EDGE_TARGET_CHANGED, this.portChanged);
    this.toolkit.bind(EVENT_EDGE_SOURCE_CHANGED, this.portChanged);
    // this.toolkit.bind(EVENT_EDGE_PATH_EDITED,this.dataChanged)
    this.toolkit.bind(EVENT_UNDOREDO_UPDATE, this.dataChanged);
    // this.toolkit.bind(EVENT_SELECTION_CLEARED,this.dataChanged)
    // this.toolkit.bind(EVENT_GRAPH_CLEAR_START,this.dataChanged)

    this.toolkit.bind(EVENT_SELECTION_CLEARED, this.selectionUpdated);
    this.toolkit.bind(EVENT_SELECT, this.selectionUpdated);
    this.toolkit.bind(EVENT_DESELECT, this.selectionUpdated);
    this.toolkit.bind(EVENT_DESTROY, this.selectionUpdated);

    // this.toolkit.bind(EVENT_NODE_MOVE_START, this.nodeMoveStartTest)
  }

  componentWillUnmount(): void {
    window.removeEventListener("keydown", this.onKeyDown);
    window.removeEventListener("keyup", this.onKeyUp);
  }
  onKeyDown(e: KeyboardEvent) {
    if (e.key === "Shift") {
      this.surface?.setMode(SurfaceMode.SELECT, true);
    }
  }
  nodeAdded(e: any) {
    if (this.loaded) {
      this.toolkit.clearSelection();
      this.toolkit.setSelection(e.node);

      var data = { ...this.toolkit.exportData() }; // JSON.parse(JSON.stringify(this.toolkit.exportData()))
    }
  }

  onKeyUp(e: any) {
    if (e.key === "Shift") {
      this.surface?.setMode(SurfaceMode.PAN, true);
    }
  }
  dataChanged(p: any) {
    if (!this.loaded) {
      return;
    }
    // var data = this.toolkit.exportData();
    this._selectionUpdated(true);
  }
  async saveQuest() {
    if (!this.props.canEdit) {
      return;
    }
    this.setState({ isSaving: true, isDirty: false });

    var data = { ...this.toolkit.exportData() }; // JSON.parse(JSON.stringify(this.toolkit.exportData()))

    let quest = this.props.quest;
    quest.data = QuestDataFromPlumb(data);

    await QuestsModel.saveQuest(quest);
    this.setState({ isSaving: false });
  }

  portChanged(p: any) {
    if (p.edge.target.id) {
      this.toolkit.updateNode(p.edge.target.id);
    }
    // this.setState({isDirty:true})
  }

  // dataGenerator (el:Element) {
  //     return NodeModel.forType(el.getAttribute("data-node-type")).Empty()
  // }

  componentDidMount() {
    this.controls.initialize(this.surface);
    this.setState({ showControls: true });
    window.addEventListener("keydown", this.onKeyDown);
    window.addEventListener("keyup", this.onKeyUp);
    setTimeout(() => {
      this.loadData();
    }, 10);
    this.setNavBar();
  }
  setNavBar() {
    const { quest, canEdit } = this.props;

    NavBar.set(
      <>
        <NavBar.Component.Back />
        <NavBar.Component.Title
          title={quest.name}
          canEdit={canEdit}
          onSave={async (newTitle: string) => {
            quest.name = newTitle;
            await QuestsModel.updateQuest(quest, true);
            this.setNavBar();
          }}
        >
          <InheritanceTag quest={quest} />
        </NavBar.Component.Title>
        <NavBar.Component.Switch
          on={this.state.inTestMode}
          onChange={(_) => {
            this.setState({ inTestMode: !this.state.inTestMode }, () => {
              this.setNavBar();
            });
          }}
        >
          TEST MODE
        </NavBar.Component.Switch>
      </>,
      null,
      null,
      quest.name
    );
  }

  loadData() {
    const data = PlumbDataFromQuest(this.props.quest);
    this.toolkit.load({ data: data });
    this.loaded = true;

    setTimeout(() => {
      if (this.props.quest.data && this.props.quest.data["start"]) {
        this.surface?.centerOn("start");
        // this.toolkit?.clearSelection()
        // this.surface?.zoomToFit()
      } else {
      }
      // _.each(this.props.quest.nodes, (n) => {
      //   if (n.type === "start") {
      //     this.surface.centerOn(n.id);
      //

      //     return;
      //   }})
    }, 300);
  }

  nodeClicked(node: Node, doubleClick: boolean) {
    (document.activeElement as any)?.blur();

    if (doubleClick) {
      if (node.type === "quest" && node.data.questSlug) {
        this.props.navigate(`/quest/${node.data.questSlug}`, this.props.quest.name);
      }
      return;
    }

    if (this.surface?.mode !== SurfaceMode.SELECT) {
      this.toolkit.clearSelection();
    }
    // this.toolkit.clearSelection()

    this.toolkit.toggleSelection(node);
  }
  removeEdge(edge: Edge) {
    if (!this.props.canEdit) {
      return;
    }
    this.toolkit.removeEdge(edge);
  }

  canvasClicked(e: Event) {
    (document.activeElement as any)?.blur();
    if (this.surface?.mode !== SurfaceMode.SELECT) {
      this.toolkit.clearSelection();
    }
  }

  selectionUpdated(_: any) {
    this._selectionUpdated();
  }
  _selectionUpdated(isDirty?: boolean) {
    let selectedNodes: any = [];
    this.toolkit.getSelection().eachNode((inx, node) => {
      selectedNodes.push(node);
    });
    if (isDirty) {
      this.setState({ selectedNodes: selectedNodes, isDirty: isDirty });
    } else {
      this.setState({ selectedNodes: selectedNodes });
    }
  }

  updateNode(node: Node, originalNode: Node, forceUpdate?: boolean) {
    if (!this.props.canEdit) {
      return;
    }
    // const edges = this.toolkit.getNode(node.id).getAllEdges();

    const newData = NodeModel.forType(node.type).PlumbData(node).node;
    this.toolkit.updateNode(node.id, newData);

    this.setState({ isDirty: true });

    setTimeout(() => {
      var data = { ...this.toolkit.exportData() }; // JSON.parse(JSON.stringify(this.toolkit.exportData()))
    }, 1000);

    if (forceUpdate) {
      CanvasHelpers.removeNonExsistingEdges(node, this.toolkit);
    }
  }
  deleteNodes(nodeOrNodes: Node | Node[]) {
    if (!this.props.canEdit) {
      return;
    }
    this.setState({ selectedNodes: [], isDirty: true });
    this.toolkit.batch(() => {
      if (!(nodeOrNodes as any).id) {
        (nodeOrNodes as Node[]).forEach((node) => {
          if (CanvasHelpers.canDelete(node)) {
            this.toolkit.removeNode(node);
          }
        });
      } else {
        this.toolkit.removeNode((nodeOrNodes as Node).id);
      }
    });
    this.toolkit.clearSelection();
  }

  duplicateNode(nodeId: string): void {
    if (!this.props.canEdit) {
      return;
    }
    const originalNode = this.toolkit.getNode(nodeId);
    if (!originalNode || isStartNode(originalNode)) {
      return;
    }

    // Get all existing nodes from exportData for collision detection
    const exportedData = this.toolkit.exportData();
    const allNodesData = exportedData.nodes || [];

    // Convert to format expected by calculateSafePosition
    const allNodes = allNodesData.map((n: any) => ({
      id: n.id,
      data: n
    }));

    // Generate unique ID
    const existingIds = allNodes.map((n: any) => n.id);
    const newId = generateUniqueNodeId(existingIds);

    // Find the original node data from the exported data to get full structure
    const originalNodeData = allNodesData.find((n: any) => n.id === nodeId);
    if (!originalNodeData) {
      return;
    }

    // Deep clone the full node data to preserve all properties including nested ones
    const clonedData = JSON.parse(JSON.stringify(originalNodeData));
    clonedData.id = newId;

    // Calculate safe position
    const newPosition = calculateSafePosition(originalNode, allNodes as any);
    clonedData.left = newPosition.left;
    clonedData.top = newPosition.top;

    // We need to use PlumbData to get the proper node structure and edges
    const model = NodeModel.forType(clonedData.type);
    if (model && model.PlumbData) {
      // Remove layout property as it will be regenerated by PlumbData
      delete clonedData.layout;

      // Get PlumbData which includes both node and edges
      const plumbData = model.PlumbData(clonedData);

      // Add the node if plumbData exists
      if (plumbData && plumbData.node) {
        this.toolkit.addNode(plumbData.node);

        // Add the edges (connections) for the gotos
        if (plumbData.edges && plumbData.edges.length > 0) {
          plumbData.edges.forEach((edge: any) => {
            // Update edge source to use new node ID
            edge.source = edge.source.replace(originalNodeData.id, newId);

            // Add the edge (this creates the visual connection and saves the goto)
            try {
              this.toolkit.addEdge(edge);
            } catch (e) {
              // Edge might fail if target doesn't exist, that's ok
            }
          });
        }
      }

      // Clear selection and select the new duplicate
      this.toolkit.clearSelection();
      this.toolkit.setSelection(newId);

      this.setState({ isDirty: true });
    }
  }

  duplicateNodes(nodeIds: string[]): void {
    if (!this.props.canEdit) {
      return;
    }
    // Get all existing data
    const exportedData = this.toolkit.exportData();
    const allNodesData = exportedData.nodes || [];

    // Filter out start nodes from the selection
    const nodesToDuplicate = allNodesData.filter((n: any) => nodeIds.includes(n.id) && n.type !== "start" && n.type !== "Start");

    if (nodesToDuplicate.length === 0) {
      return; // Nothing to duplicate (all were start nodes)
    }

    // Generate new IDs for all duplicates
    const existingIds = allNodesData.map((n: any) => n.id);
    const newNodeIds: string[] = [];
    const idMapping = new Map<string, string>();

    nodesToDuplicate.forEach((node: any) => {
      const newId = generateUniqueNodeId([...existingIds, ...newNodeIds]);
      newNodeIds.push(newId);
      idMapping.set(node.id, newId);
    });

    // Clear current selection
    this.toolkit.clearSelection();

    // Create duplicates with position offsets
    const allNodes = allNodesData.map((n: any) => ({
      id: n.id,
      data: n
    }));

    const duplicatedNodes: string[] = [];
    const duplicatedNodeData: any[] = [];
    const edgesToAdd: any[] = [];

    nodesToDuplicate.forEach((originalNodeData: any, index: number) => {
      const newId = newNodeIds[index];

      // Deep clone the node data
      const clonedData = JSON.parse(JSON.stringify(originalNodeData));
      clonedData.id = newId;

      // Calculate safe position with incremental offset
      const originalNode = { id: originalNodeData.id, data: originalNodeData };
      const updatedAllNodes = [
        ...allNodes,
        ...duplicatedNodes.map((id) => {
          const node = allNodesData.find((n: any) => n.id === id) || { id, data: { left: 0, top: 0 } };
          return { id, data: node };
        })
      ];

      const newPosition = calculateSafePosition(originalNode as any, updatedAllNodes as any);
      clonedData.left = newPosition.left;
      clonedData.top = newPosition.top;

      // Store the cloned data temporarily for goto processing
      duplicatedNodeData.push(clonedData);
    });

    // Update gotos for all duplicated nodes using helper function BEFORE adding to toolkit
    // clearExternalGotos = false for same-quest duplication (preserve external gotos)
    const updatedNodesWithGotos = updateGotosForDuplicates(duplicatedNodeData, idMapping, false);

    // Now add the nodes with corrected gotos to the toolkit
    updatedNodesWithGotos.forEach((clonedData, index) => {
      const newId = clonedData.id;

      // Remove layout property as it will be regenerated
      delete clonedData.layout;

      // Get model and add node with edges
      const model = NodeModel.forType(clonedData.type);
      if (model && model.PlumbData) {
        const plumbData = model.PlumbData(clonedData);

        if (plumbData && plumbData.node) {
          // Add the node
          this.toolkit.addNode(plumbData.node);
          duplicatedNodes.push(newId);

          // Store edges to add after all nodes are created
          if (plumbData.edges && plumbData.edges.length > 0) {
            plumbData.edges.forEach((edge: any) => {
              // Update edge source to use new node ID - find original ID from clonedData
              const originalNodeId = Object.keys(idMapping.entries()).find((originalId) => idMapping.get(originalId) === newId);
              if (originalNodeId && edge.source) {
                edge.source = edge.source.replace(originalNodeId, newId);
              }
              edgesToAdd.push(edge);
            });
          }

          // Add to selection (will be done after all nodes are created)
          // this.toolkit.addToSelection(newId);
        }
      }
    });

    // Add all edges after all nodes are created
    edgesToAdd.forEach((edge) => {
      try {
        this.toolkit.addEdge(edge);
      } catch (e) {
        // Edge might fail if target doesn't exist, that's ok
      }
    });

    // Select all duplicated nodes after they're fully rendered
    setTimeout(() => {
      // Get the actual node objects to ensure they exist before selection
      const nodeObjects = duplicatedNodes.map((id) => this.toolkit.getNode(id)).filter((n) => n);

      if (nodeObjects.length === duplicatedNodes.length) {
        // All nodes exist, select them as a group
        this.toolkit.setSelection(nodeObjects);
      } else {
        // Fallback to individual selection if some nodes aren't ready
        duplicatedNodes.forEach((nodeId) => {
          this.toolkit.toggleSelection(nodeId);
        });
      }
    }, 50);

    this.setState({ isDirty: true });
  }

  async duplicateNodesToQuest(nodeIds: string[], targetQuestSlug: string): Promise<void> {
    if (!this.props.canEdit) {
      return;
    }
    // Get all existing data from current quest
    const exportedData = this.toolkit.exportData();
    const allNodesData = exportedData.nodes || [];

    // Filter out start nodes from the selection
    const nodesToDuplicate = allNodesData.filter((n: any) => nodeIds.includes(n.id) && n.type !== "start" && n.type !== "Start");

    if (nodesToDuplicate.length === 0) {
      return; // Nothing to duplicate (all were start nodes)
    }

    // Load target quest
    const targetQuest = await QuestsModel.loadQuest(targetQuestSlug, true);
    if (!targetQuest) {
      throw new Error(`Target quest not found: ${targetQuestSlug}`);
    }

    // Get existing nodes from target quest
    const targetQuestData = targetQuest.data || {};
    const existingTargetNodeIds = Object.keys(targetQuestData);

    // Generate new IDs for all duplicates
    const newNodeIds: string[] = [];
    const idMapping = new Map<string, string>();

    nodesToDuplicate.forEach((node: any) => {
      const newId = generateUniqueNodeId([...existingTargetNodeIds, ...newNodeIds]);
      newNodeIds.push(newId);
      idMapping.set(node.id, newId);
    });

    // Find the rightmost and bottommost positions in selected set
    const maxLeft = Math.max(...nodesToDuplicate.map((n) => n.left));
    const maxTop = Math.max(...nodesToDuplicate.map((n) => n.top));

    // Create virtual anchor point using rightmost left and bottommost top
    const virtualAnchorPoint = {
      left: maxLeft,
      top: maxTop
    };

    // Position that anchor point relative to target quest's start node
    const targetStartNode = "start" in targetQuestData ? targetQuestData.start : null;
    const anchorTargetPosition = targetStartNode
      ? {
          left: targetStartNode.left - OFFSET_INCREMENT * 2,
          top: targetStartNode.top - OFFSET_INCREMENT * 2
        }
      : { left: 100, top: 100 }; // Default position if no start node or matrix quest

    // Create duplicates for target quest
    const updatedTargetData = { ...targetQuestData };

    nodesToDuplicate.forEach((originalNodeData: any, index: number) => {
      const newId = newNodeIds[index];

      // Deep clone the node data
      const clonedData = JSON.parse(JSON.stringify(originalNodeData));
      clonedData.id = newId;

      // Position relative to the virtual anchor point
      const relativeLeft = originalNodeData.left - virtualAnchorPoint.left;
      const relativeTop = originalNodeData.top - virtualAnchorPoint.top;
      clonedData.left = anchorTargetPosition.left + relativeLeft;
      clonedData.top = anchorTargetPosition.top + relativeTop;

      // Remove layout property as it will be regenerated
      delete clonedData.layout;

      // Add to target quest data (without goto updates yet)
      updatedTargetData[newId] = clonedData;
    });

    // Update all gotos using the helper function
    const clonedNodesList = Object.values(updatedTargetData).filter((node: any) => newNodeIds.includes(node.id));

    const updatedNodesWithGotos = updateGotosForDuplicates(clonedNodesList, idMapping, true);

    // Apply the updated nodes back to the target data
    updatedNodesWithGotos.forEach((node) => {
      updatedTargetData[node.id] = node;
    });

    // Save updated target quest
    const updatedTargetQuest = {
      ...targetQuest,
      data: updatedTargetData
    } as QuestInterface;

    QuestsModel.saveQuest(updatedTargetQuest);

    // Reload quest data to ensure fresh state and then navigate
    await QuestsModel.loadQuestsList(true);

    // Use hard navigation to force a fresh load of the quest
    window.location.href = `/quest/${targetQuestSlug}`;
  }

  // updateNodeInQuest(newData: Node) {
  //   const newData = NodeModel.forType(node.type).PlumbData(node).node;
  //   this.props.quest.nodes[node.id] = newData;
  //   this.setState({ isDirty: true });
  // }

  shouldDrag(): boolean {
    return true;
  }

  panToAndSelectNode(node: Node) {
    this.toolkit.clearSelection();
    this.toolkit.setSelection(node.id);
    this.surface?.centerOn(node.id);
  }

  render() {
    const { quest, navigate, canEdit } = this.props;
    const { showControls, isDirty, isSaving, selectedNodes, inTestMode } = this.state;

    const selectedNode: any = selectedNodes.length === 1 ? this.state.selectedNodes[0] : null;

    const jsonView =
      quest && Member.isDev ? (
        <div className="jsonView">
          <JsonView value={quest.data} />
        </div>
      ) : null;

    return (
      <div className={selectedNodes.length ? "EditorCanvas hasSelections" : "EditorCanvas noSelections"}>
        {jsonView}
        <div className="surfaceWrapper">
          <JsPlumbToolkitSurfaceComponent
            renderParams={this.renderParams}
            toolkit={this.toolkit}
            view={this.view}
            ref={(c: any) => {
              if (c && c.surface !== this.surface) {
                this.surfaceComponent = c;
                this.surface = c.surface;
              }
            }}
          />
        </div>
        <CanvasControls ref={(c) => (this.controls = c)} />

        {showControls && <JsPlumbToolkitMiniviewComponent surface={this.surface!} />}

        <EditorSidePanel
          toolkit={this.toolkit}
          showControls={showControls}
          surface={this.surface!}
          selectedNode={selectedNode}
          selectedNodes={selectedNodes}
          updateNode={this.updateNode}
          deleteNodes={this.deleteNodes}
          duplicateNode={this.duplicateNode}
          duplicateNodes={this.duplicateNodes}
          duplicateNodesToQuest={this.duplicateNodesToQuest}
          inTestMode={inTestMode}
          quest={quest}
          saveQuest={this.saveQuest}
          canEdit={canEdit}
        />
        <EditorSaveButton isDirty={isDirty} isSaving={isSaving} save={this.saveQuest} canEdit={canEdit} />
        <IssuesView quest={quest} panToAndSelectNode={this.panToAndSelectNode} />

        {showControls && <BrainsDropdown selectedQuest={quest} navigate={navigate} canEdit={canEdit} />}
      </div>
    );
  }
}
